import { MathHelper } from "../../../core/utils/MathHelper";

export class SoundConfig {
    
    public static bigWinLoop(lvl:number):string{ 
        const level = MathHelper.clamp(lvl,1,7);
        if(level > 6) return "bigwinLevel6Sub";
        return "bigwinLevel" + level;
    }

    public static readonly BASE_GAME_AMBIANCE:string = "main";
    public static readonly FS_GAME_AMBIANCE:string = "fs";
    public static readonly FS_INTRO_AMBIANCE:string = "fsIntro";
    public static readonly GAME_INTRO_SOUND:string = "mainIntro";

    public static readonly GAME_INTRO_START:string = "startGame";
    public static readonly BOX_MULTIES_POP:string = "fsIntroMultiplierBoxes";

    public static readonly CELL_TOPBOT_OPEN:string = "cellDoorOpen";
    public static readonly CELL_TOPBOT_CLOSE:string = "cellDoorClose";

    public static readonly CELL_OPEN_REMAINING:string = "fsIntroOpenRemainingCells";

    public static readonly FS_OUTRO_BUSS:string = "startGameAfterFs";
    public static readonly FS_OUTRO:string = "fsOutro";

    public static readonly FS_START_RIFF:string = "fsIntroStart";

    public static readonly FS_START_INTRO_GAMBLING:string = "fsIntroToGamble";
    public static readonly FS_START_INTRO_BADGES:string = "fsGambleThumbBadgesEnter";
    
    public static readonly SETUP_GAMBLE_CLICK:string = "fsGambleButtonGamble";
    public static readonly SETUP_COLLECT_CLICK:string = "fsGambleButtonCollect";

    public static readonly SETUP_HATCH_OPEN:string = "fsGambleHatchOpens";
    public static readonly SETUP_HATCH_CLOSES:string = "fsGambleHatchCloses";

    public static readonly SETUP_RESULT_SCALING:string = "fsGambleBadgeScaleIn";
    public static readonly SETUP_RESULT_PASSED:string = "fsGambleBadgeGold";
    public static readonly SETUP_RESULT_MAX:string = "fsGambleBadgeGoldMax";
    public static readonly SETUP_RESULT_THUMB:string = "fsGambleBadgeGoldThumb";

    public static readonly SKIP_KILL_BASE:string[] = ["scatterToWild","xWaysDouble","xWaysSingle"]

    public static readonly SKIP_SCATTER_BASEGAME:string = "scatterToWildAbort";
    public static readonly SKIP_XWAYSDOUBLE_BASEGAME:string = "xWaysDoubleAbort";
    public static readonly SKIP_XWAYS_BASEGAME:string = "xWaysSingleAbort";


    public static readonly SETUP_RESULT_FAIL:string = "fsGambleBadgeExplode";

    public static readonly SETUP_MINI_EXPLODE:string = "fsGambleThumbBadgeExplode";
    public static readonly SETUP_MINI_MOVING:string = "fsGambleThumbBadgeSweep";

    public static readonly SETUP_NEXT_BURNER:string = "fsGambleBurn";

    public static readonly SETUP_2_DOOR_OPEN:string = "fsIntroCellDoorOpens";

    public static readonly SETUP_2_CELL_EXPLODE:string = "fsIntroCharacterReveal";
    public static readonly SETUP_2_COLLECT_VALUES:string = "fsIntroGatherSpins";
    public static readonly SETUP_2_APPLY_VALUES:string = "fsIntroAddMultiplier";

    public static readonly SETUP_2_REMOVE_SIDES:string = "fsIntroToFs";
    public static readonly SETUP_2_APPLY_TOP_BOT_BARS:string = "fsAddTopBotReel";
    

    public static readonly MANIAC_1:string = "psycho-manhunt1";
    public static readonly MANIAC_2:string = "psycho-manhunt2";

    public static readonly INTRO_FOLDER:string = "introFolder";

    public static readonly REELS_SPINNING:string = "reelsSpinning";
    public static readonly REELS_DEFAULT_BOUNCE:string[] = ["reelLanding"];
    public static readonly BAR_LANDING_BOUNCE:string = "fsTopBotReelLanding";

    public static readonly FS_MYSTERY_REVEAL:string = "fsRevealSymbols";

    public static readonly FS_JAIL_DOOR_OPEN:string = "fsJailDoorsOpen";
    public static readonly FS_JAIL_DOOR_CLOSE:string = "fsJailDoorsClose";

    public static readonly FS_BLACKBOARD_STROKE:string = "fsBlackboard";
    public static readonly FS_CHAR_IN:string = "fsCharacterIn";

    public static readonly FS_TOTAL_SPINS:string = "fsTotalSpins";

    public static readonly FS_MULT_TURN:string = "fsMultiplierTurn";

    public static readonly FS_LINE_FIRE:string = "fsFire";
    
    public static readonly FS_JUMPINGWILD_MOVE:string = "fsJumpingWildMove";
    public static readonly FS_JUMPINGWILD_IN:string = "fsJumpingWildIn";

    public static readonly FS_POLICE_IN:string = "fsPoliceIn";
    public static readonly FS_POLICE_SWITCH:string = "fsCharacterInPolice";

    public static readonly FS_MULTIPLIER_COLLECT:string = "fsMultiplierCollect";

    public static readonly FS_ENDS:string = "fsEnds";
    public static readonly FS_ENDS_BAD:string = "fsEndsBad";

    public static readonly BG_GOING_DOWN:string = "fsDown";
    public static readonly BG_GOING_UP:string = "fsUp";

    public static readonly BAR_OPEN:string = "jailDoorOpen";

    public static readonly BIG_WIN_INIT:string = "bigwinInitialWin";
    public static readonly BIG_WIN_INIT_COUNTUP:string = "bigwinInitialCountup";
    
    public static readonly BIG_WIN_COUNT:string = "bigwinCountup";

    public static readonly BIG_WIN_LVL:string = "bigwinLevel"; // Usng 1-6;
    public static readonly BIG_WIN_ENDS:string = "bigwinEnds"; 
    public static readonly BIG_WIN_ENDS_CAP:string = "bigwinEndsCapwin"; 
    
    public static readonly BIG_WIN_ATTENTION:string = "bigwinAnticipation";
    public static readonly BIG_WIN_ATTENTION_DOOR:string = "bigwinAnticipationDoor";

    public static readonly CAP_WIN_COUNT:string = "capwinCountup"; 
    public static readonly CAP_WIN_MUSIC:string = "capwinMusic";
    public static readonly CAP_WIN_END:string = "capwinEnds";
    

    public static readonly WIN_LVL:string[] = ["winTiny","winSmall","winMedium","winLarge"];
    public static readonly HIGHLIGHTWIN_LVL:string[] = ["betlinesHighlightSmall","betlinesHighlightMedium","betlinesHighlightLarge"];
    public static readonly HIGHLIGHTWIN_COMMON:string = "betlineHighlight";
    
    public static readonly SCATTER_LAND:string[] = ["scatter1","scatter2","scatter3","scatter4","scatter5"];
    public static readonly SCATTER_ATTENTION:string = "scatterAnticipation";
    public static readonly SCATTER_ATTENTION_MISS:string = "scatterAnticipationFail";
    public static readonly SCATTER_ATTENTION_START:string = "scatterAnticipationReelStart";

    public static readonly SCATTER_TO_WILD:string = "scatterToWild";
    public static readonly SCATTER_TO_WILD_FS:string = "scatterToWildFs";

    public static readonly FS_PLUS_SPINS:string = "fsPlusSpins";

    public static readonly REVEAL_RAZOR_BOUNCE:string = "razorbladeLands";

    public static readonly WILD_LAND:string = "wildLanding";
    public static readonly WILD_SPLIT:string = "wildSplit";
    public static readonly BONUS_WILD_FIRE:string = "bonusWildFire";
    public static readonly BONUS_WILD_SPLIT:string = "bonusWildSplit";
    public static readonly MULT_UPGRADE:string = "fsMultiplierUpgrade";

    public static readonly WILD_EXPLODE:string = "wildExplode";

    public static readonly WIN_COUNT:string = "countup";

    public static readonly XWAYS_DOUBLE:string = "xWaysDouble";
    public static readonly XWAYS_SINGLE:string = "xWaysSingle";

    public static readonly XWAY_REVEAL_SINGLE:string = "xWaysSingleReveal";
    public static readonly XWAY_REVEAL_DOUBLE:string = "xWaysDoubleReveal";

    public static readonly CONTINUE_CLICK:string = "continueButton"; 

    
}